import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterEntities'
})
export class FilterEntitiesPipe implements PipeTransform {
  //there is another pipe named dropDownFilterSubEntitie.pipe.ts that handle the subEntities filtering optionally
  transform(entities: any[], searchValue: string): any[] {

    if (!searchValue || (searchValue && searchValue.trim() == "")) {
      return entities; // Return the original array if there's no search value
    }

    const lowercaseSearch = searchValue.toLowerCase();

    return entities.filter((entity) => {
      const nameOrLabel = (entity.category && entity.name ? entity.category + ' ' + entity.name : null) || entity.referenceName || entity.name || entity.label
        || entity.nom || entity.category || entity.fullName || entity.fullname || entity.firstName || entity.lastName || entity.title
        || entity.libelle || entity.nomComplet || entity.nomSociete || entity || entity.value;
      if (nameOrLabel && typeof nameOrLabel === 'string') {
        const lowercaseNameOrLabel = this.removeSpecialFrenshChars(nameOrLabel.toLowerCase());
        return lowercaseNameOrLabel.includes(this.removeSpecialFrenshChars(lowercaseSearch));
      }

      if (nameOrLabel?.value && typeof nameOrLabel?.value === 'string') {
        const lowercaseNameOrLabel = this.removeSpecialFrenshChars(nameOrLabel?.value.toLowerCase());
        return lowercaseNameOrLabel.includes(this.removeSpecialFrenshChars(lowercaseSearch));
      }

      return entities;
    });
  }

  removeSpecialFrenshChars(str: string): string {
    let normalizedStr = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    // Replace '-' with ' '
    normalizedStr = normalizedStr.replace(/-/g, ' ');

    return normalizedStr;
  }
}